export class StringUtil {

  /** 
   * SafeValue ensures that we we always get an empty string back when the text value is null or undefined.     
   * This simplifies code checks.
   * The text value is always converted to string.
   * This function is null-ref safe.
   * @param value The value that you want to convert to a string. This can be null, undefined, or any other object.
   * @param defaultValue This value will be returned when the value is null or undefined.
   * 
   * @example
   * const result = StringUtil.SafeValue(5); // '5'
   * @example
   * const result = StringUtil.SafeValue(null); // ''
   */
  public static safeValue(value: any, defaultValue: string = ''): string {
    if (value === undefined || value === null) {
      return defaultValue;
    }    

    // Convert any other value to string.
    return ('' + value);
  }

  /**
   * SafeLength properly handles null and undefined cases.
   * This function is null-ref safe.
   * @param value The value that you want to convert to a string. This can be null, undefined, or any other object.
   */
  public static safeLength(value: any): number {
    return StringUtil.safeValue(value).length;
  }

  /**
   * Check if the text value is Null, Undefined, or a zero length string.
   * This function is null-ref safe.
   * @param value The value that you want to convert to a string. This can be null, undefined, or any other object.
   */
  public static isNullOrEmpty(value: any): boolean {
    let result: boolean = (StringUtil.safeLength(value) == 0);
    return result;
  }

  /**
   * Method which will combine prop1 and prop2 and return a string array of combined values
   * @param prop1 Property 1 which can be a string or string array
   * @param prop2 Property 2 which can be a string or string array
   * @returns String array of combined values
   */
  public static combineStringOrStringArrayProps(prop1: string | string[], prop2: string | string[]): string[] {
    //check if prop1 and prop2 is already an array, if not wrap it in an array
    let combined = Array.isArray(prop1) ? prop1 : [prop1];
    combined = Array.isArray(prop2) ? combined.concat(prop2) : combined.concat([prop2]);

    // return the combined array
    combined = combined.filter((val) => val !== '');
    return combined;
}
}